class AdmUnit {
  constructor(divUniqueId, slotName, sizeArray) {
    this.htmlElement = this.createHtmlElement(divUniqueId);

    this.divUniqueId = divUniqueId;
    this.slotName = slotName;
    this.sizeArray =
      typeof sizeArray === "string" ? JSON.parse(sizeArray) : sizeArray;
  }

  createHtmlElement(divUniqueId) {
    const element = jQuery("<div></div>");

    element.attr("id", divUniqueId);
    element.css({
      textAlign: "center",
    });

    return element;
  }

  defineAndDisplaySlot() {
    const _that = this;
    // console.log(this.slotName, this.sizeArray, this.divUniqueId);
    // window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function () {
      googletag
        .defineSlot(_that.slotName, _that.sizeArray, _that.divUniqueId)
        .addService(googletag.pubads());
      // googletag.pubads().enableSingleRequest();
      // googletag.enableServices();
      googletag.display(_that.divUniqueId);
    });
  }
}

export default AdmUnit;
